import { Customer } from '../types';

const filterCustomers = (value: string, customers: Customer[]): Customer[] => {
  if (!value) return customers;

  const lowerInput = value.toLowerCase();
  return customers.filter(
    (customer) =>
      customer.Name?.toLowerCase().includes(lowerInput) ||
      customer.TypeTitle?.toLowerCase().includes(lowerInput) ||
      customer.WorkEmail?.toLowerCase().includes(lowerInput) ||
      customer.WorkPhone?.toLowerCase().includes(lowerInput),
  );
};

export default filterCustomers;
